import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import React from 'react'
import type { PaginationSize } from './Pagination'
import { sizes } from './Pagination'

interface EllipsisItemProps {
  disabled: boolean
  size: PaginationSize
}

function EllipsisItem({
  disabled,
  size,
}: PropsWithChildren<EllipsisItemProps>): JSX.Element {
  return (
    <li>
      <div
        aria-hidden
        className={clsx(
          'flex justify-center items-center text-sm font-normal rounded-full leading-relaxed cursor-default',
          sizes[size],
          disabled ? 'text-black-25 cursor-not-allowed' : 'text-black-60',
        )}
      >
        &#8230;
      </div>
    </li>
  )
}

export default EllipsisItem
